import React from 'react';

import { Box, Card, Separator } from '@betterment/samba-react';
import { CardLoader, SambaAutoLink } from '@betterment/shared-components';
import { FourOhOneKContributionsHeader } from '@betterment/shared-components/src/components/four-oh-one-k-contributions/FourOhOneKContributionsHeader';
import { FourOhOneKContributionsSummary } from '@betterment/shared-components/src/components/four-oh-one-k-contributions/FourOhOneKContributionsSummary';

import { useFourOhOneKContributionsQuery } from './hooks';

import { Message as GraphQLMessage } from '../graphql/schema';
import MessageBox from '../Shared/components-v2/message-box/message-box';
import { urlBuilder } from '../Shared/urlBuilder';

const Controller: React.FC<React.PropsWithChildren> = () => {
  const { isLoading, employeeContributions, employers, messages } = useFourOhOneKContributionsQuery();

  if (isLoading) return <CardLoader />;
  if (!employeeContributions || !employers) return null;

  const hasSolo401k: boolean = employers.some(employer => employer.soloFourOhOneKPlan);
  const hasOnlySolo401k: boolean = employers.every(employer => employer.soloFourOhOneKPlan);
  const hasValidMessages = messages && messages.length > 0;

  return (
    <Card css={{ padding: 'space.300', display: 'grid', gap: 'space.300' }}>
      <Card.Header>
        <FourOhOneKContributionsHeader employers={employers} hasOnlySolo401k={hasOnlySolo401k} />
      </Card.Header>
      <Separator />
      <Card.Content>
        <Box css={{ display: 'grid', gap: 'space.300', marginTop: 'space.25' }}>
          <FourOhOneKContributionsSummary
            employeeContributions={employeeContributions}
            employers={employers}
            hasSolo401k={hasSolo401k}
          />
          {hasValidMessages && (
            <MessageBox messages={messages as GraphQLMessage[]} location="goal_overview_four_oh_one_k_contributions" />
          )}

          <Separator />
          <SambaAutoLink to={urlBuilder.appFourOhOneKDetails.absolute()}>See details</SambaAutoLink>
        </Box>
      </Card.Content>
    </Card>
  );
};

export default Controller;
